module.exports = __webpack_public_path__ + "img/polygon-right-disable.8ac4ee5c.svg";